import * as React from 'react';
import { SVGProps } from 'react';
export const CollectionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M23.956 21.319 19.808 1.594A2.002 2.002 0 0 0 17.433.045L11.58 1.303a2.01 2.01 0 0 0-1.537 2.375l4.149 19.724a2 2 0 0 0 2.374 1.553l5.852-1.257a2.011 2.011 0 0 0 1.537-2.38ZM12 3.269v-.011l5.85-1.25.416 1.983-5.85 1.259L12 3.269Zm1.25 5.922-.419-1.987 5.853-1.258.417 1.988L13.25 9.19ZM22 21.742l-5.85 1.25-.416-1.983 5.85-1.259.416 1.981v.011ZM8 1H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM2 3h6v2H2V3Zm6 20H2v-2h6v2Z"
    />
  </svg>
);
